function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.5 1.70005C11.1134 1.70005 10.8 1.38665 10.8 1.00005C10.8 0.613449 11.1134 0.300049 11.5 0.300049H15C15.3866 0.300049 15.7 0.613449 15.7 1.00005V4.50005C15.7 4.88665 15.3866 5.20005 15 5.20005C14.6134 5.20005 14.3 4.88665 14.3 4.50005V2.69L7.99496 8.99502C7.7216 9.26839 7.27838 9.26839 7.00501 8.99502C6.73165 8.72166 6.73165 8.27844 7.00501 8.00507L13.31 1.70005H11.5ZM0.299988 5.50005C0.299988 3.4566 1.95653 1.80005 3.99999 1.80005H8.49999C8.88659 1.80005 9.19999 2.11345 9.19999 2.50005C9.19999 2.88665 8.88659 3.20005 8.49999 3.20005H3.99999C2.72973 3.20005 1.69999 4.22979 1.69999 5.50005V12C1.69999 13.2703 2.72973 14.3 3.99999 14.3H10.5C11.7702 14.3 12.8 13.2703 12.8 12V7.50005C12.8 7.11345 13.1134 6.80005 13.5 6.80005C13.8866 6.80005 14.2 7.11345 14.2 7.50005V12C14.2 14.0435 12.5434 15.7 10.5 15.7H3.99999C1.95653 15.7 0.299988 14.0435 0.299988 12V5.50005Z",
  fill: "#738BA5"
});

function SvgExpandIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandIcon);
export default __webpack_public_path__ + "static/media/ExpandIcon.2af88307.svg";
export { ForwardRef as ReactComponent };